<template>
<div class="chapter">
<div class="inner_page">
<div class="chapterbody">
<a id="page_vi"></a>
<a id="page_vii"></a>
<p class="epi" id="epi"><i>And if the worldly forget you,</i><br/>
<i>say to the silent earth: I flow.</i><br/>
<i>To the swift water say: I am.</i><br/>
<br/>
   —Rainer Maria Rilke<br/>
   <i>The Sonnets to Orpheus</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?1a4e5dc9